export enum SelectionModeEnum {
    'SINGLE' = 'single',
    'MULTIPLE' = 'multiple',
    'RANGE' = 'range'
}
